import { render, staticRenderFns } from "./forgetPsw.vue?vue&type=template&id=7c0d48be&"
import script from "./forgetPsw.vue?vue&type=script&lang=js&"
export * from "./forgetPsw.vue?vue&type=script&lang=js&"
import style0 from "./forgetPsw.vue?vue&type=style&index=0&id=7c0d48be&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports